import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { getSharedConversation } from "~/services/shares";
import { ReadOnlyConversationView } from "./ReadOnlyConversationView";

// Renders a project's featured session read-only, from its share token —
// the same content `SharedConversationRoute` shows at the standalone
// `/shared/c/:token` URL, but nested under the project route so the
// sidebar/layout stay in place instead of leaving the project entirely.
export const ProjectFeaturedSessionRoute = () => {
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return null;
  }

  return <ProjectFeaturedSession key={token} token={token} />;
};

interface ProjectFeaturedSessionProps {
  token: string;
}

const ProjectFeaturedSession = ({ token }: ProjectFeaturedSessionProps) => {
  useDocumentTitle("Featured Session");

  const fetcher = useCallback(
    (signal: AbortSignal) => getSharedConversation(token, { signal }),
    [token]
  );

  return (
    <ReadOnlyConversationView
      conversationId={null}
      shareToken={token}
      fetcher={fetcher}
      bannerSubtitleContent="Featured session · Read-only."
      ownerVerb="Shared by"
      notFoundTitle="This featured session isn't available"
      notFoundBody="It may have been unfeatured, or its share link revoked."
      readOnlyFeedback
      hideTitle
    />
  );
};
